import { render, staticRenderFns } from "./CampaignsApprove.vue?vue&type=template&id=5e41f1fb&scoped=true&"
import script from "./CampaignsApprove.vue?vue&type=script&lang=js&"
export * from "./CampaignsApprove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e41f1fb",
  null
  
)

export default component.exports